import Vue from 'vue'
import Vuex from 'vuex'
import {api} from '@/api/api'

Vue.use(Vuex)

const otpData={
  id:null,
  title: null,
  hideCountdown: true,
  getCodeApi: null,
  getCodeApiData:null,
  confirmCodeApiData: null,
  confirmCodeApi: null,
  phoneOnly: false,
  showContacts: true,
  showClose: true
}

export const store = new Vuex.Store({
  state:{
    settings: {},
    userInfo: {},
    showOtpVerification: false,
    otpData,
    otpConfirmed: false,
    otpBackendError: null,
    documentTypes: [],
    showTestModeModal: false,
    tradeLimitsData: {},
    haveNewMessage: false,
    haveAccountsUpdate: false,
    haveNewDocs: false

  },
  getters: {
    appSettings: (state) => state.settings,
    userFullName: state => {
      return Object.keys(state.userInfo).length > 1 ? state.userInfo.first_name + ' ' + state.userInfo.last_name : undefined
    },
    settings: state => state.settings,
    showTestModeModal: state => state.showTestModeModal,
    userInfo: state => state.userInfo,
    check_status: state => state.userInfo.check_status,
    showOtpVerification: state => state.showOtpVerification,
    otpData: state => state.otpData,
    otpConfirmed: state => state.otpConfirmed,
    otpBackendError: state => state.otpBackendError,
    documentTypes: state => state.documentTypes || [],
    hasUnreadMessages: state => state.userInfo.unread_messages,
    tradeLimitsData: state => state.tradeLimitsData,
    haveNewMessage: state => state.haveNewMessage,
    haveAccountsUpdate: state => state.haveAccountsUpdate,
    haveNewDocs: state => state.haveNewDocs,

  },
  mutations: {
    SET_APP_SETTINGS: (state, payload) => {
      state.settings = payload
    },
    SET_SHOW_TEST_MODE_MODAL: (state, payload) => {
      state.showTestModeModal = payload
    },
    SET_USER_INFO:(state, payload) => {
      state.userInfo = payload
    },
    SET_SETTINGS: (state, payload) => {
      state.settings = payload
    },
    SHOW_OTP: (state, payload) => {
      state.otpData = payload
      state.showOtpVerification = true
    },
    HIDE_OTP: (state) => {
      state.showOtpVerification = false
      state.otpConfirmed = false
      state.otpData = otpData
    },
    CONFIRM_OTP: (state, payload) => {
      state.otpConfirmed = payload
    },
    SET_DOCUMENT_TYPES: (state,payload) => {
      state.documentTypes = payload
    },
    LOGOUT: (state) => {
      state.userInfo = {}
    },
    SET_UNREAD_MESSAGES: (state, payload) => {
      state.userInfo.unread_messages = payload
    },
    SET_UNREAD_DOCS: (state, payload) => {
      state.userInfo.unread_docs = payload
    },
    SET_UNSIGNED_DOCS: (state, payload) => {
      state.userInfo.unread_unsigned_docs = payload
    },
    SET_OTP_BACKEND_ERROR: (state, payload) => {
      state.otpBackendError = payload
    },
    SET_TRADE_LIMITS_DATA: (state,payload) => {
      state.tradeLimitsData = payload
    },

    SET_HAVE_NEW_MESSAGE: (state, payload) => {
      state.haveNewMessage = payload
    },
    SET_HAVE_ACCOUNTS_UPDATE: (state, payload) => {
      state.haveAccountsUpdate = payload
    },
    SET_HAVE_NEW_DOCS: (state, payload) => {
      state.haveNewDocs = payload
    }
  },
  actions: {
    setAppSettings: async(context) => {
      const {data} = await  api.profile.settings()
      context.commit('SET_APP_SETTINGS', data)
      localStorage.setItem('access_ttl_limit', data['AUTH_ACCESS_TOKEN_TTL']*60*1000)
      localStorage.setItem('refresh_ttl_limit', data['AUTH_REFRESH_TOKEN_TTL']*60*1000)
    },
    setUserInfo: async (context, payload) => {
      if(payload) {
        context.commit('SET_USER_INFO', payload)
      } else {
        const res = await api.auth.userInfo()
        context.commit('SET_USER_INFO', res.data)
      }
    },
    setShowTestModeModal: (context, payload) => {
      context.commit('SET_SHOW_TEST_MODE_MODAL', payload)
    },
    setDocumentTypes: async (context) => {
      try {
        const {data} = await api.cabinet.getDocumentTypes()
        data.unshift({title: {uk: 'Всі', en: 'All'}})
        context.commit('SET_DOCUMENT_TYPES', data)
      } catch(err) {
        console.log(err)
      }
    },
    showOtp:(context, payload) => {
      context.commit('SHOW_OTP', payload)
    },
    hideOtp:(context) => {
      context.commit('HIDE_OTP')
    },
    confirmOtp: (context, payload) => {
      context.commit('CONFIRM_OTP', payload)
      setTimeout(()=>{
      context.commit('HIDE_OTP')
      },0)
    },
    setHasUnreadMessages: (context,payload) => {
      context.commit('SET_UNREAD_MESSAGES', payload)
    },
    setHasUnreadDocs: (context,payload) => {
      context.commit('SET_UNREAD_DOCS', payload)
    },
    setHasUnsignedDocs: (context,payload) => {
      context.commit('SET_UNSIGNED_DOCS', payload)
    },
    setSettings: async (context) => {
      try {
        const {data} = await api.profile.settings()
        context.commit('SET_SETTINGS', data)
      } catch(err) {
        console.log(err)
      }
    },
    setOtpBackendError: (context, payload) => {
      context.commit('SET_OTP_BACKEND_ERROR', payload)
    },

    logout:(context) => {
      context.commit('LOGOUT')
    },
    setTradeLimitsData: async (context) => {
      try {
        const {data} = await api.cabinet.getBalances()
        context.commit('SET_TRADE_LIMITS_DATA', data)
      } catch(err) {
        this.$toast.error(this.$t('notifications.something-went-wrong'))
        console.log(err)
      }

    },
    updateTradeLimitsData: async (context) => {
      try {
        const {data} = await api.cabinet.updateBalances()
        context.commit('SET_TRADE_LIMITS_DATA', data)
      }catch(err) {
        this.$toast.error(this.$t('notifications.something-went-wrong'))
        console.log(err)
      }
    },
    setHaveNewMessage: (context, payload) => {
      context.commit('SET_HAVE_NEW_MESSAGE', payload)
    },
    setHaveAccountsUpdate: (context, payload) => {
      context.commit('SET_HAVE_ACCOUNTS_UPDATE', payload)
    },
    setHaveNewDocs: (context, payload) => {
      context.commit('SET_HAVE_NEW_DOCS', payload)
    }


  },
})
